import React, {Component} from 'react';
import { Button, Row, Col } from 'antd';

class CounsellingMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show:false
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick(){
    this.setState({show: !this.state.show});
  }

//const CounsellingMain = ({item, index}) => {
//  const status = csMeta.status;
  render() {
    const {item, index} = this.props;
    const gender = (item.get('gender') === 'male') ? 'is-mr' : 'is-ms';
    const highlight = (index === 0)?'highlight':'';

    return (
      <section className={`${gender} counselling-main ${highlight}`}>
      <Row type="flex" justify="center" align="middle">
      <Col xs={22} lg={16}>
        <div className="counselling-main__title">
          {item.get('title')}
        </div>
        <div className="counselling-item__school">
          <Row type="flex" justify="space-around" align="middle" gutter={8}>
            <Col span={4}>
              <img className="counselling-main__img" src={item.get('school_logo')} alt={item.get('school')}/>
            </Col>
            <Col span={20}>
              <div className="counselling-main__school_name">{item.get('school')} <span>({item.get('school_type')})</span></div>
              <div className="counselling-main__school_course">{item.get('course')}</div>
            </Col>
          </Row>
        </div>
        <div>
          {item.get('acquired_visa') &&
          <span className="counselling-main__status">
          <i className="fa fa-calendar"></i> 延長期間: <span className="counselling-main__status_meta">{item.get('term')}<span>ヶ月</span></span>
            {item.get('extend_visa') &&
            <span>トラトラで更新</span>
            }
          </span>
          }
          <span className="counselling-main__status">
            <i className="fa fa-dollar"></i> 更新時の費用: <span className="counselling-main__status_meta"><span>$</span>{item.get('cost')}</span>
            {item.get('split_payment') &&
            <span>
              分割 <span>$</span>{item.get('split_cost')}
            </span>
            }
          </span>
        </div>

        <div>
          <div className="counselling-main__desc" dangerouslySetInnerHTML={{__html: item.get('desc')}}></div>
        </div>

        <div>
          <Button className='btn btn-outline-primary mr-2' onClick={this.onClick}>詳しく読む</Button>
          <Button className='btn btn-xs btn-primary' href={`/school/${item.get('school_type')}/${item.get('school_key')}`}>この学校の詳細を見る</Button>
        </div>

        {this.state.show &&
        <Row>
          {item.get('acquired_visa') &&
          <Col xs={12} className="mb-2">
            <div className="">更新されたビザ</div>
            <div className="">{item.get('acquired_visa_text')}</div>
          </Col>
          }
          {item.get('monthly_tuition') &&
          <Col xs={12} className="mb-2">
            <div className="">学費月額</div>
            <div className="">
              <span>$</span>{item.get('monthly_tuition')}</div>
          </Col>
          }
          <Col xs={12} className="mb-2">
            <div className="">職業</div>
            <div className="">{item.get('occupation_text')}</div>
          </Col>
          <Col xs={12} className="mb-2">
            <div className="">英語レベル</div>
            <div className="">{item.get('english_level_text')}</div>
          </Col>
        </Row>
        }
      </Col>
      </Row>
      </section>
    );
  }
}

export default CounsellingMain;



// WEBPACK FOOTER //
// ./src/pages/school/components/CounsellingMain.js